import type { ViewClaimResults } from 'all-in-one-shared-api';
import { getLocaleDescription } from 'utils/getLocaleDescription';

export type FormattedClaimData = ViewClaimResults & {
  claimTypeDescription: string;
  diagnosisDescription: string;
  doctorName: string;
};

const formatClaimCardData =
  (isEnglish = true) =>
  ({
    benefit,
    claimType,
    diagnosis,
    doctor,
    ...data
  }: Readonly<ViewClaimResults>): Readonly<FormattedClaimData> & Readonly<ViewClaimResults> => {
    let claimTypeDescription: string | undefined;
    if (benefit && benefit.code) {
      claimTypeDescription = getLocaleDescription(isEnglish)(benefit);
    }
    if (!claimTypeDescription) {
      claimTypeDescription = getLocaleDescription(isEnglish)(claimType);
    }

    return {
      ...data,
      benefit,
      claimType,
      diagnosis,
      doctor,
      claimTypeDescription,
      doctorName: getLocaleDescription(isEnglish)(doctor),
      diagnosisDescription: getLocaleDescription(isEnglish)(diagnosis),
    };
  };

export default formatClaimCardData;
